/**
 * Route for `igaming-depositing-player-count`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingDepositingPlayerCountPage } from "../features/igaming-depositing-player-count/IgamingDepositingPlayerCountPage";

export const igamingDepositingPlayerCountRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-depositing-player-count",
	component: IgamingDepositingPlayerCountPage,
});

export default igamingDepositingPlayerCountRoute;
